// DateDivider.tsx - Redux Migration
import React from 'react';
import { useAppSelector } from '../../../hooks/hooks';
import { selectMessagesStatus } from '../../../store/slices/messagesSlice'
import moment from 'moment';

interface DateDividerProps {
  date: string;
}

export const DateDivider: React.FC<DateDividerProps> = ({ date }) => {
  // Get loading state from Redux to potentially show loading indicators
  const messagesStatus = useAppSelector(selectMessagesStatus);
  
  // Format date using a memoized selector instead of passed function
  const getFormattedTime = (date: string): string => {
    const time = moment(date);
    const now = moment();
    
    if (time.format("L") === now.format("L")) {
      return "Today";
    }
    
    if (time.isSame(now.subtract(1, "days"), "day")) {
      return "Yesterday";
    }
    
    return time.format("MMMM D, YYYY");
  };

  return (
    <div className="floating-date-header">
      <div className="date-bubble">
        <span className="date-text">
          {getFormattedTime(date)}
        </span>
      </div>
    </div>
  );
};